import React from "react";
import ReadMore from "./readMore";
import { dateFormat } from "../helper";

export const DisplayContent = function({
  content = {},
  classes = "",
  length,
  showCreatedInfo = true
}) {
  const { comment, createdBy, createdDate } = content;
  return (
    <div className={classes}>
      {showCreatedInfo ? (
        <p style={{ color: "black", marginBottom: "5px" }}>
          <span>{createdBy}</span> | <span>{dateFormat(createdDate)}</span>
        </p>
      ) : null}
      <ReadMore indentation={"-"} length={length || 200} content={comment} />
    </div>
  );
};
